import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import {
  ModalDispatcher,
  ModalProvider,
  ToastDispatcher,
  ToastProvider,
  HistoryStateProvider,
} from '@pcmp/react-providers';
import { ToastItem } from '@/components/helpers/toast-item';
import { ModalWrapper } from '@/components/helpers/modal-wrapper';
import PageLayout from '@/components/layouts/page-layout';
import { LocaleListener } from '@/components/helpers/language-switcher/locale-listener';
import Authentication from '@/components/providers/authentication';
import { OnboardingTutorial } from '@/components/tutorials/onboarding';
import { LoadingProvider } from '@/components/helpers/loading/context';
import CtaHandler from '@/components/providers/cta';
import RouteTracker from '@/components/helpers/route-tracker';

const AppLayout: FC = () => {
  return (
    <ToastProvider ToastItem={ToastItem}>
      <ModalProvider ModalWrapper={ModalWrapper}>
        <Authentication>
          <CtaHandler>
            <HistoryStateProvider>
              <LoadingProvider>
                <ToastDispatcher />
                <ModalDispatcher />
                <LocaleListener />
                <OnboardingTutorial />
                <RouteTracker />
                <PageLayout>
                  <Outlet />
                </PageLayout>
              </LoadingProvider>
            </HistoryStateProvider>
          </CtaHandler>
        </Authentication>
      </ModalProvider>
    </ToastProvider>
  );
};

export default AppLayout;
